import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { mainSiteUrl } from '@/mocks/categories';

export default function ArticlePreview() {
  const scrollTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-secondary-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide uppercase mb-4">
            Guide &amp; Ratgeber
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            OOPBuy Spreadsheet – Alle Artikel
          </h2>
          <p className="text-foreground-500 text-base max-w-xl mx-auto">
            Alles was du über OOPBuy Spreadsheet wissen musst – von der ersten Nutzung bis zu
            Profi-Tipps für die besten Finds.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((art) =>
            art.hasPage ? (
              <Link
                key={art.id}
                to={`/artikel/${art.id}`}
                onClick={scrollTop}
                className="group relative overflow-hidden rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-300 cursor-pointer flex flex-col h-full"
              >
                <div className="relative w-full h-48 overflow-hidden">
                  <img
                    src={art.image}
                    alt={art.title}
                    title={art.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-full bg-white/90 backdrop-blur-sm text-primary-700 text-xs font-semibold">
                      {art.tag}
                    </span>
                  </div>
                </div>
                <div className="p-5 flex-1 flex flex-col">
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-700 transition-colors duration-300 leading-snug">
                    {art.title}
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed flex-1">
                    {art.excerpt}
                  </p>
                  <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-200/50">
                    <span className="text-foreground-400 text-xs">{art.date}</span>
                    <span className="inline-flex items-center gap-1 text-primary-600 text-xs font-semibold group-hover:gap-2 transition-all duration-300">
                      <span>Artikel lesen</span>
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              </Link>
            ) : (
              <a
                key={art.id}
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="group relative overflow-hidden rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-300 cursor-pointer flex flex-col h-full"
              >
                <div className="relative w-full h-48 overflow-hidden">
                  <img
                    src={art.image}
                    alt={art.title}
                    title={art.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-full bg-white/90 backdrop-blur-sm text-secondary-700 text-xs font-semibold">
                      {art.tag}
                    </span>
                  </div>
                </div>
                <div className="p-5 flex-1 flex flex-col">
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-700 transition-colors duration-300 leading-snug">
                    {art.title}
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed flex-1">
                    {art.excerpt}
                  </p>
                  <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-200/50">
                    <span className="text-foreground-400 text-xs">{art.date}</span>
                    <span className="inline-flex items-center gap-1 text-primary-600 text-xs font-semibold group-hover:gap-2 transition-all duration-300">
                      <span>Mehr erfahren</span>
                      <i className="ri-arrow-right-up-line"></i>
                    </span>
                  </div>
                </div>
              </a>
            )
          )}
        </div>
      </div>
    </section>
  );
}